import { Installation, Account } from 'projects/flow-gui-installation/views/installation'
var routes = [].concat([
  {
    path: '/installation',
    component: Installation,
    exact: true
  },
  {
    path: '/installation/:ip/:key',
    component: Installation,
    exact: true
  },
  {
    path: '/account',
    component: Account,
    exact: true
  }
])
module.exports = routes



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/routes/index.js